<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    title="续保失败"
    :footer-hide="true"
    width="630"
    class="my-modal top p-b"
  >
    <div class="follow-up-container">
      <div class="fee-status">
        <Form
          ref="form"
          :model="form"
          :label-width="80"
          class="modal-form"
        >
          <FormItem
            prop="serviceStateDetail"
            label="失败类型"
            :rules="$units.formRule.required(`请选择失败类型`)"
            key="error"
          >
            <div class="failure-type">
              <div
                class="failure-btn"
                :class="{ active: item.value == form.serviceStateDetail }"
                v-for="item in failureType"
                @click="form.serviceStateDetail = item.value"
                :key="item.value"
              >
                {{ item.label }}
              </div>
            </div>
          </FormItem>

          <FormItem
            key="beizhu1"
            prop="serviceContent"
            label="备注"
            :rules="$units.formRule.required('请填写失败原因')"
            style="margin:30px 0;"
          >
            <Input
              v-model="form.serviceContent"
              placeholder="请填写续保失败原因"
              maxlength="50"
              show-word-limit
              type="textarea"
            />
          </FormItem>
        </Form>
      </div>

      <div class="action-buttom">
        <div class="buttom-box">
          <Button class="cancel" @click="visible = false">取消</Button>
          <Button type="primary" @click="ok">确认</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ["id", "getInsureList"],
  data() {
    return {
      visible: false,
      failureType: [
        {
          label:'已理赔',
          value:'1'
        },
        {
          label:'已过最晚续保日',
          value:'2'
        },
        {
          label:'健康原因',
          value:'3'
        },
        {
          label:'产品原因',
          value:'4'
        },
        {
          label:'经济原因',
          value:'5'
        },
        {
          label:'已退保',
          value:'6'
        },
        {
          label:'其他',
          value:'7'
        }
      ],
      form: {
        serviceStateDetail:'',
        serviceContent:''
      }
    };
  },

  methods: {
    open(data) {
      this.$refs.form.resetFields();      
      this.visible = true;  
      this.form.id = data.id
    },

    ok() {
      this.$refs.form.validate().then((isok) => {
        if (!isok) {
          return;
        }
        this.submit();
      });
    },

    submit() {
      let data = {
        id: this.form.id,
        serviceState: 2,
        payState: 3,//续费状态
        serviceContent: this.form.serviceContent,//备注
        serviceStateDetail: this.form.serviceStateDetail,//失败类型
      };
      this.$http({
        url: `/buz/policyShortRenewalRecord/updateRenewalRecord`,
        type: "POST",
        data,
        apiPermissionCode:'renewalManage_01_6'
      }).then((res) => {
        this.$notice.success("操作成功");
        this.getInsureList();
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-up-container {
  padding: 0 0 5px 10px;
  .fee-status {
    .total {
      display: flex;
      border: 1px solid #e8eaec;
      border-top: none;
      border-right: none;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.23%;
        border-right: 1px solid #e8eaec;
      }
    }
    .failure-type {
      display: flex;
      flex-wrap: wrap;
      .failure-btn {
        width: 105px;
        height: 32px;
        border-radius: 4px;
        background: #f5f7f9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3c464f;
        font-size: 14px;
        margin-bottom: 10px;
        margin-right: 10px;
      }

      .failure-btn:hover {
        cursor: pointer;
      }

      & .active {
        background: rgba(235, 241, 255, 0.39);
        color: #236dff;
        border: 1px solid #236dff;
      }
    }
  }
}
.action-buttom {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  .buttom-box {
    width: 50%;
    display: flex;
    justify-content: center;
    justify-content: space-between;
    Button {
      width: 140px;
      height: 36px;
    }
    .cancel {
      width: 120px;
      border-color: #236dff;
      color: #236dff;
    }
  }
}
</style>